import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin, Suggestion } from '../../aiSuggestionsPluginType';

import { applyToolCalls } from './toolCalls/applyToolCalls';

export function applySuggestion({
	api,
	suggestion,
}: {
	api?: ExtractInjectionAPI<AiSuggestionsPlugin>;
	suggestion: Suggestion;
}): void {
	api?.core.actions.execute(({ tr }) => {
		const appliedTr = applyToolCalls({ tr, suggestion });
		appliedTr.setMeta('scrollIntoView', false);

		return appliedTr;
	});
}
